import React from 'react';
import { Th } from '../../../components/Tbl';

const RowHeader = props => (
  <tr>
    <Th>No.</Th>
    {
      props.timer ?
      <Th>Spend Time</Th>
      :
      null
    }
    <Th>Order Detail</Th>
    <Th>Rack</Th>
    <Th>Total Price</Th>
    <Th>Payment</Th>
    <Th>Updated</Th>
    <Th>Action</Th>
  </tr>
)

export default RowHeader;